(() => {
  const bar = document.querySelector('[data-sf-product-sticky]');
  if (!bar) return;
  const button = bar.querySelector('button');
  const sourceId = bar.dataset.source;
  // Dawn's animated product ancestors have transforms, which otherwise contain fixed positioning.
  document.body.append(bar);
  const source = () => document.getElementById(sourceId);
  let footerVisible = false;
  const sync = () => {
    const original = source();
    const disabled = !original || original.disabled || original.getAttribute('aria-disabled') === 'true';
    const label = original?.querySelector('span')?.textContent.trim() || 'Indisponibil';
    const hidden = footerVisible || !!document.querySelector('#sf-age[open], cart-drawer.active, quick-add-modal[open]');
    if (button.disabled !== disabled) button.disabled = disabled;
    if (button.textContent !== label) button.textContent = label;
    if (bar.hidden !== hidden) bar.hidden = hidden;
  };
  button.addEventListener('click', () => { const original = source(); if (original && !button.disabled) original.click(); });
  const productInfo = source()?.closest('product-info') || source()?.closest('.product__info-container');
  if (productInfo) new MutationObserver(sync).observe(productInfo, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
  document.querySelectorAll('#sf-age, cart-drawer').forEach(el => new MutationObserver(sync).observe(el, { attributes: true, attributeFilter: ['open', 'class'] }));
  const footer = document.querySelector('.sf-footer');
  if (footer) new IntersectionObserver(entries => { footerVisible = entries[0].isIntersecting; sync(); }).observe(footer);
  sync();
})();
